export default __webpack_public_path__ + "static/ec2-ffc7d21c8f930a493f4baa63b504eb79.png";